import React from 'react';
import { Plus } from 'react-feather';
import { Link } from 'react-router-dom';
import { useInternationalization } from '../../../features/i18n';

const PageHeaderDesktop = () => {
  const { translate } = useInternationalization()

  return (
    <div className="flex justify-between items-start">
      <h1 className="text-4xl font-bold font-primary mb-8">
        {translate('EVENT', 'our')}
      </h1>
      <Link
        className="text-sm text-primary flex items-center cursor-pointer"
        to="/dashboard/events/create"
      >
        <Plus className="mr-1" style={{width: '14px'}}/>
        <p>{translate('EVENT', 'create')}</p>
      </Link>
    </div>
  )
}

export { PageHeaderDesktop }
